import ReactGA from 'react-ga4';

import { isDev } from '@/lib/utils';

let isGAInitialized = false;

export const initializeGA = () => {
  if (!isGAInitialized) {
    ReactGA.initialize(process.env.PREACT_APP_GA_APPID, { debug: isDev() });
    isGAInitialized = true;
  }
};

export const getClientId = async () => {
  if (!isGAInitialized) {
    initializeGA();
  }
  return new Promise((resolve, reject) => {
    ReactGA.ga((tracker) => {
      const clientId = tracker?.get('clientId');
      if (clientId) {
        resolve(clientId);
      } else {
        reject(Error('Cannot get client id of GA'));
      }
    });
  });
};

export const logPageViewGA = (page, resetReferrer, delay = true) => {
  if (!isGAInitialized) {
    initializeGA();
  }

  if (resetReferrer) {
    ReactGA.set({ referrer: '' });
  }

  if (delay) {
    setTimeout(() => {
      ReactGA.send({ hitType: 'pageview', page, title: page });
    }, 2000);
  } else {
    ReactGA.send({ hitType: 'pageview', page, title: page });
  }
};

export const logGAEvent = async (category, action, label, value = 1) => {
  // category ->  content type: chat/ugc
  // actions -> action the user took: sent-message-chat, liked-photo, reacted-comment-clip
  // label -> the habitat slug
  ReactGA.event({
    category,
    action,
    label,
    value,
  });
};

export const logLandingButton = async (action) => {
  const { pathname } = window.location;
  const modifiedPath = ['/', '/home'].includes(pathname) ? '/zoolife' : pathname;
  await logGAEvent('PressLandingButton', `${modifiedPath}-${action}`);
};

export const setGAUserId = (userId) => {
  if (!isGAInitialized) {
    initializeGA();
  }

  ReactGA.set({ userId, anonymizeIp: true, forceSSL: true });
};

/**
 * Stop attributing hits to the user who just left.
 *
 * Unlike Mixpanel's identity this is not shared between the apps — `ReactGA.set` configures this
 * page's tracker — so each app clears its own and no cross-app coordination applies. That is why the
 * Forget calls this unconditionally while the Mixpanel reset is guarded.
 *
 * `null` rather than `undefined`, and the difference is the whole function. `react-ga4` renames
 * `userId` to `user_id` and hands the value straight to `gtag('set', …)`, and GA4 only treats an
 * explicit `null` as "forget this id" — `undefined` leaves the previous one in place, so every hit
 * after a logout was still being attributed to the account that had just left.
 */
export const clearGAUserId = () => {
  if (!isGAInitialized) return;

  ReactGA.set({ userId: null });
};

export const logExperiment = (experimentId, variant) => {
  ReactGA.ga('set', 'exp', `${experimentId}.${variant}`);
};
